"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault").default;
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = exports.HouseTimeOutlineSVG = void 0;
var _extends2 = _interopRequireDefault(require("@babel/runtime/helpers/extends"));
var _objectWithoutProperties2 = _interopRequireDefault(require("@babel/runtime/helpers/objectWithoutProperties"));
var _propTypes = _interopRequireDefault(require("prop-types"));
var _react = _interopRequireDefault(require("react"));
var _Icon = require("../Icon");
var _excluded = ["children"];
var innerSvg = '<path d="M16 3.52l9.92 9.34V28H6V12.93l10-9.41M16 26a7 7 0 10-7-7 7 7 0 007 7m0-24.5a2 2 0 00-1.2.4L4.71 11.4A2 2 0 004 12.93V28a2 2 0 002 2h20a2 2 0 002-2V12.93a2 2 0 00-.71-1.53L17.2 1.9a2 2 0 00-1.2-.4zM16 24a5 5 0 115-5 5 5 0 01-5 5z"/><path d="M18.89 20.45A1 1 0 0118 21a.93.93 0 01-.45-.11L15 19.62V17a1 1 0 012 0v1.38l1.45.73a1 1 0 01.44 1.34z"/>';
var HouseTimeOutlineSVG = function HouseTimeOutlineSVG(_ref) {
  var children = _ref.children,
    rest = (0, _objectWithoutProperties2.default)(_ref, _excluded);
  return /*#__PURE__*/_react.default.createElement("svg", (0, _extends2.default)({
    viewBox: "0 0 32 32"
  }, rest), children, /*#__PURE__*/_react.default.createElement("g", {
    stroke: "none",
    dangerouslySetInnerHTML: {
      __html: innerSvg
    }
  }));
};
exports.HouseTimeOutlineSVG = HouseTimeOutlineSVG;
HouseTimeOutlineSVG.propTypes = process.env.NODE_ENV !== "production" ? {
  children: _propTypes.default.node
} : {};
var _default = (0, _Icon.withIcon)(HouseTimeOutlineSVG);
exports.default = _default;